import { useEffect, useState } from 'react';

const query = q => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(q) : null);

// Live boolean for a CSS media query
export const useMediaQuery = q => {
  const [matches, setMatches] = useState(() => !!query(q)?.matches);

  useEffect(() => {
    const mql = query(q);
    if (!mql) return undefined;
    const onChange = e => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [q]);

  return matches;
};

// Mouse/trackpad users get hover-only flourishes (cursor, magnetic buttons, spotlights)
export const useFinePointer = () => useMediaQuery('(hover: hover) and (pointer: fine)');
